import { useEffect, useState } from "react";
import axios from "axios";
import { ACCESS_KEY } from "../config";

function HostRewards() {
  const [search, setSearch] = useState("");
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showBanModal, setShowBanModal] = useState(false);
  const [showUnbanModal, setShowUnbanModal] = useState(false);

  const usersPerPage = 20;

  useEffect(() => {
    getHostUsers();
  }, []);

  // ==========================================
  // GET HOST USERS
  // ==========================================
  const getHostUsers = async () => {
    try {
      const response = await axios.get(
        "https://admin.butterlive.co.in/management/host-reward-users",
        {
          headers: {
            key: ACCESS_KEY,
          },
        }
      );

      setUsers(response.data.data || []);
    } catch (error) {
      console.log(error);
      alert("Failed to load host users");
    }
  };

  // ==========================================
  // SEARCH
  // ==========================================
  const filteredUsers = users.filter((user) =>
    (user.name || "").toLowerCase().includes(search.toLowerCase()) ||
    String(user.uniqueId || "").includes(search)
  );

  // ==========================================
  // PAGINATION
  // ==========================================
  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;

  const currentUsers = filteredUsers.slice(
    indexOfFirstUser,
    indexOfLastUser
  );

  const totalPages = Math.ceil(
    filteredUsers.length / usersPerPage
  );

  // ==========================================
  // OPEN BAN / UNBAN CONFIRMATION
  // ==========================================
  const openBanModal = (user) => {
    setSelectedUser(user);
    setShowBanModal(true);
  };

  const openUnbanModal = (user) => {
    setSelectedUser(user);
    setShowUnbanModal(true);
  };

  // ==========================================
  // HOST REWARD BAN
  // ==========================================
  const handleBan = async () => {
    if (!selectedUser) return;

    try {
      const response = await axios.post(
        "https://admin.butterlive.co.in/management/toggle-host-reward-ban",
        {
          userId: selectedUser.userId,
          hostRewardBanned: true,
        },
        {
          headers: {
            key: ACCESS_KEY,
          },
        }
      );

      if (response.data.status) {
        setUsers((prevUsers) =>
          prevUsers.map((user) =>
            user.userId === selectedUser.userId
              ? {
                  ...user,
                  hostRewardBanned: true,
                }
              : user
          )
        );

        setShowBanModal(false);
        setSelectedUser(null);
      } else {
        alert(response.data.message || "Failed to ban reward");
      }
    } catch (error) {
      console.log(error);
      alert("Host Reward Ban Failed");
    }
  };

  // ==========================================
  // HOST REWARD UNBAN
  // ==========================================
  const handleUnban = async () => {
    if (!selectedUser) return;

    try {
      const response = await axios.post(
        "https://admin.butterlive.co.in/management/toggle-host-reward-ban",
        {
          userId: selectedUser.userId,
          hostRewardBanned: false,
        },
        {
          headers: {
            key: ACCESS_KEY,
          },
        }
      );

      if (response.data.status) {
        setUsers((prevUsers) =>
          prevUsers.map((user) =>
            user.userId === selectedUser.userId
              ? {
                  ...user,
                  hostRewardBanned: false,
                }
              : user
          )
        );

        setShowUnbanModal(false);
        setSelectedUser(null);
      } else {
        alert(response.data.message || "Failed to unban reward");
      }
    } catch (error) {
      console.log(error);
      alert("Host Reward Unban Failed");
    }
  };

  return (
    <div>

      {/* PAGE HEADER */}
      <div className="page-header">
        <h1 className="page-title">
          Host Rewards
        </h1>
      </div>

      {/* SEARCH */}
      <div className="top-bar">
        <input
          type="text"
          placeholder="Search Name / User ID"
          className="search-box"
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setCurrentPage(1);
          }}
        />
      </div>

      {/* TABLE */}
      <div className="table-card">
        <table
          width="100%"
          cellPadding="12"
          style={{ minWidth: "1000px" }}
        >
          <thead>
            <tr>
              <th>Sr No</th>
              <th>Photo</th>
              <th>Name</th>
              <th>User ID</th>
              <th>Sex</th>
              <th>Reward Status</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {currentUsers.map((user, index) => {
              const isBanned =
                user.hostRewardBanned === true;

              return (
                <tr key={user.userId || index}>

                  <td>
                    {indexOfFirstUser + index + 1}
                  </td>

                  <td>
                    {user.image ? (
                      <img
                        src={user.image}
                        alt="Profile"
                        className="user-avatar"
                      />
                    ) : (
                      "—"
                    )}
                  </td>

                  <td>
                    {user.name || "—"}
                  </td>

                  <td>
                    {user.uniqueId || "—"}
                  </td>

                  <td>
                    {user.gender || "—"}
                  </td>

                  <td>
                    <span
                      className={
                        isBanned
                          ? "status-banned"
                          : "status-active"
                      }
                    >
                      {isBanned
                        ? "Banned"
                        : "Active"}
                    </span>
                  </td>

                  <td>
                    <button
                      onClick={() =>
                        isBanned
                          ? openUnbanModal(user)
                          : openBanModal(user)
                      }
                      className={
                        isBanned
                          ? "ban-btn ban-btn-unban"
                          : "ban-btn ban-btn-active"
                      }
                    >
                      {isBanned
                        ? "Unban"
                        : "Ban Reward"}
                    </button>
                  </td>

                </tr>
              );
            })}
          </tbody>
        </table>

        {/* PAGINATION */}
        <div className="pagination">

          <button
            disabled={currentPage === 1}
            onClick={() =>
              setCurrentPage(currentPage - 1)
            }
          >
            Previous
          </button>

          <span>
            Page {currentPage} of {totalPages}
          </span>

          <button
            disabled={
              currentPage === totalPages ||
              totalPages === 0
            }
            onClick={() =>
              setCurrentPage(currentPage + 1)
            }
          >
            Next
          </button>

        </div>
      </div>

      {/* BAN MODAL */}
      {showBanModal && selectedUser && (
        <div className="modal-overlay">
          <div className="modal-box">

            <h3>
              Disable Host Reward
            </h3>

            <p>
              Are you sure you want to disable
              Host Reward for{" "}
              <strong>
                {selectedUser.name}
              </strong>
              ?
            </p>

            <button
              onClick={() => {
                setShowBanModal(false);
                setSelectedUser(null);
              }}
            >
              Cancel
            </button>

            <br />
            <br />

            <button
              className="ban-btn ban-btn-active"
              onClick={handleBan}
            >
              Confirm Ban
            </button>

          </div>
        </div>
      )}

      {/* UNBAN MODAL */}
      {showUnbanModal && selectedUser && (
        <div className="modal-overlay">
          <div className="modal-box">

            <h3>
              Enable Host Reward
            </h3>

            <p>
              Are you sure you want to enable
              Host Reward for{" "}
              <strong>
                {selectedUser.name}
              </strong>
              ?
            </p>

            <button
              onClick={() => {
                setShowUnbanModal(false);
                setSelectedUser(null);
              }}
            >
              Cancel
            </button>

            <br />
            <br />

            <button
              className="ban-btn ban-btn-unban"
              onClick={handleUnban}
            >
              Confirm Unban
            </button>

          </div>
        </div>
      )}

    </div>
  );
}

export default HostRewards;
